export const fmtQtd = (v, unit) => {
  const n = Number(v) || 0;
  if ((unit || "").toLowerCase() === "un" && Math.abs(n - Math.round(n)) < 1e-9) return String(Math.round(n));
  const t = n.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
  return (t || "0").replace(".", ",");
};
export const fmtBRL = (v) => `R$ ${(Number(v) || 0).toFixed(2).replace(".", ",")}`;
export const fmtData = (iso) => { try { const d = new Date(iso); return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) + " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }); } catch { return iso || ""; } };
